import React from 'react';
import { Box, withStyles } from '@material-ui/core';
import { Modal, Typography, ErrorIcon } from '@orijinworks/frontend-commons';
import styles, {
    mainWrapperStyles,
    continueButtonProps,
    cancelButtonProps,
} from './export-limit-error-modal.styles';

/**
 * Pre-styled red circle icon - avoids type: 'confirmation' which forces footer flex-start.
 */
const ErrorIconCircle = ({ classes }) => (
    <Box className={classes.errorIconCircle}>
        <ErrorIcon htmlColor="white" className={classes.errorIcon} />
    </Box>
);

/**
 * Modal shown when export exceeds 50K limit (CC-13964).
 * Design: Figma Export Error - https://www.figma.com/file/tOWB1KeKlPB63y5q0rV6XA (node 12667:8831)
 */
const ExportLimitErrorModal = ({ open = false, onClose, classes }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            onContinue={onClose}
            heading=""
            labelledBy="Export limit exceeded"
            describedBy="You can export up to 50,000 entries at a time. Try applying filters to narrow down your export and reduce the number of entries for export."
            actionBtnText="Update Selection"
            Icon={<ErrorIconCircle classes={classes} />}
            showCrossIcon
            modalType={{ type: 'normal', status: 'info', size: 'medium' }}
            showFooter={true}
            cancelBtnText=" "
            cancelButtonProps={cancelButtonProps}
            continueButtonProps={continueButtonProps}
            styles={{ mainWrapperStyles }}
        >
            <Box className={classes.contentBox}>
                <Typography component="p" variant="h5" className={classes.title}>
                    You're exporting too many entries
                </Typography>
                <Typography component="p" variant="body1" className={classes.body}>
                    You can export up to 50,000 entries at a time. Try applying filters to narrow down your export and reduce the number of entries for export.
                </Typography>
            </Box>
        </Modal>
    );
};

ExportLimitErrorModal.defaultProps = {
    open: false,
    onClose: undefined,
};

export default withStyles(styles)(ExportLimitErrorModal);
